import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ArrowLeftIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "m4.414 9.002 3.293 3.3A1.003 1.003 0 0 1 6.997 14a1 1 0 0 1-.704-.281l-5-5.01a1.003 1.003 0 0 1 0-1.417l5-5.01a.999.999 0 0 1 1.695.711c.002.263-.099.516-.281.705l-3.293 3.3H14A.999.999 0 0 1 15 8a1.003 1.003 0 0 1-1 1.002H4.414Z", fill: "currentColor" })));
});
ArrowLeftIcon.displayName = 'ArrowLeftIcon';
export default ArrowLeftIcon;
